import React from "react";
import FrameworksDashboard from "./FrameworksDashboard";
import { TriangleAlertIcon } from "lucide-react";

const FrameworksLab = () => {
  return (
    <div>
      <div className="mb-4 border rounded p-2">
        <TriangleAlertIcon
          className="text-accent w-4 h-4 inline-block mr-2"
          strokeWidth={1.5}
        />
        <span className="align-middle text-sm text-muted-foreground">
          Note: This comparison is subjective. See the{" "}
          <a
            href="https://newsletter.victordibia.com/p/10-ways-to-compare-and-select-the"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            blog post
          </a>{" "}
          and{" "}
          <a
            href="https://www.youtube.com/watch?v=WyWrfoNo4_E&t=242s&ab_channel=DesigningWithAI"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            video
          </a>{" "}
          on how the criteria and scores are derived. Raw data is available on{" "}
          <a
            href="https://github.com/victordibia/designing-multiagent-systems/tree/main/research/frameworks"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            GitHub
          </a>{" "}
          (see mistakes?{" "}
          <a
            href="https://github.com/victordibia/designing-multiagent-systems/issues/new"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            open an issue
          </a>
          ).
        </span>
      </div>
      <div className="  border-dashed border-b mb-4"></div>
      <FrameworksDashboard />
    </div>
  );
};

export default FrameworksLab;
